import { WLabel } from 'constants/enums';
import { URL } from 'constants/urlMaps';
import { selectByWL } from 'utils/wLabel';

interface IFaqLink {
  title: string;
  url: URL;
}

export const links: IFaqLink[] = selectByWL({
  [WLabel.Globus]: [
    {
      title: 'Как это работает',
      url: URL.how_it_works,
    },
    {
      title: 'Выбор товара и оплата',
      url: URL.payment,
    },
    { title: 'Доставка', url: URL.delivery },
    {
      title: 'Пользовательское соглашение',
      url: URL.agreement,
    },
  ],
  [WLabel.Default]: [
    {
      title: 'Как это работает',
      url: URL.how_it_works,
    },
    {
      title: 'Выбор товара и оплата',
      url: URL.payment,
    },
    { title: 'Доставка', url: URL.delivery },
    { title: 'Доставка для бизнеса', url: `${URL.business}?ref=site_info` },
    { title: 'Обмен и возврат товара', url: URL.obmen_i_vozvrat_tovara },
    { title: 'Партнерство', url: URL.partnership },
    { title: 'Работа в igooods', url: URL.rabota_v_igooods },
  ],
});

export const subLinks: IFaqLink[] = [
  {
    title: 'Пользовательское соглашение',
    url: URL.agreement_page,
  },
  {
    title: 'Публичная оферта',
    url: URL.offer,
  },
  {
    title: 'Правила участия в программе начисления баллов',
    url: URL.igooods_points_rules,
  },
  {
    title: 'Реквизиты исполнителей заказов',
    url: URL.fr_details,
  },
  {
    title: 'Персональные данные',
    url: URL.personal_data,
  },
];
